module.exports = __webpack_public_path__ + "static/media/Montserrat-Italic.a7063e0c.ttf";